import type { CheckFileLabel } from '@/entities/checkFileLabel'
import type { Database } from '~/apis/generated/database'

export type CheckFile = Database['public']['Tables']['check_files']['Row']

export type CheckFileCreateParams = Database['public']['Tables']['check_files']['Insert']
export type CheckFileUpdateParams = Database['public']['Tables']['check_files']['Update']

export type CheckFileWithLabels = CheckFile & { check_file_labels: CheckFileLabel[] }
export type ViewCheckFile = CheckFileWithLabels & { translatedStatus: string; translatedType: string }

export const MAX_CHECK_SHEET_ASSIGNMENT_COUNT = 30
export const MAX_CHECK_FILES_COUNT = 500
